<template>
  <footer class="footer">
    <div class="footer-content">
      <img src="@/assets/images/logo.png" alt="Moin Mation Logo" class="footer-logo" />

      <nav class="footer-nav">
        <router-link to="/" @click="closeMenu">Home</router-link>
        <router-link to="/about" @click="closeMenu">About</router-link>
        <router-link to="/works" @click="closeMenu">Works</router-link>
        <router-link to="/contact" @click="closeMenu">Contact</router-link>
      </nav>

      <p class="copyright">
        © All rights reserved by <strong>Moin Mation</strong>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
.footer {
  background-color: #111;
  padding: 40px 20px;
  text-align: center;
}

.footer-content {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo {
  width: 120px;
  margin-bottom: 34px;
}

.footer-nav {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.footer-nav a {
  font-size: 16px;
  font-weight: 400;
  color: #555;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-nav a:hover {
  color: #fff;
}

.footer p {
  font-size: 14px;
  color: #666;
}

.footer strong {
  color: #fff;
  font-weight: 500;
}

/* Mobile-first responsiveness */
@media (max-width: 600px) {
  .footer {
  }

  .footer-logo {
    width: 100px;
  }

  .footer-nav {
    gap: 20px;
  }

  .footer-nav a {
    font-size: 15px;
  }

  .footer p {
    font-size: 13px;
  }
}

nav a.router-link-exact-active {
  color: #ffffff;
}
</style>
